/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { InputSwitch } from 'primereact/inputswitch';
import { Dialog } from 'primereact/dialog';
import { useGetSignedUrlMutation } from '../../features/coaching/coachingHistoryGrid/coachingHistoryGridSlice';
import {
    useAcknowledgeConversationMutation,
    useCoachingConversationMutation,
} from '../../features/coaching/conversationLogs/conversationLogSlice';
import {
    selectCurrentEmpid,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectIsPseudoSupervisor,
} from '../../pages/login/authSlice';
import { changeDateFormate, datetimeToDate } from '../../utils/dateFormat';
import CoachingToDo from '../CoachingToDo/CoachingToDo';
import CoachingShoutOut from '../coachingShoutOut/coachingShoutOUt';
import { DeleteCoachingDialog } from '../deleteCoaching/DeleteCoachingDialog';
import { useDeleteCoachingMutation } from '../../features/coaching/coachingSlice';
import ReplyConversationLog from '../replyConversation/ReplyConversationLog';
import {
    useCreateCoachingToDoMutation,
    useConversationAckReqCheckQuery,
} from '../CoachingToDo/CoachingToDoSlice';
import { ROLES } from '../../constants';
import DescriptionBox from '../descriptionBox/DescriptionBox';

interface ReadConversationModalBodyProps {
    listItem: any;
    commentView: boolean;
    setCommentView: (commentView: boolean) => void;
    isResponse: boolean;
    setIsResponse: (isResponse: boolean) => void;
    receiverName?: string;
    receiverId?: string;
    convId?: number;
    coreValueId?: number;
    setSelectedRowItem?: (selectedRowItem: any) => void;
    setDisplayModal: (displayModal: boolean) => void;
    readOnly?: boolean;
    acknowledged?: boolean;
}

const ReadConversationModalBody = (props: ReadConversationModalBodyProps) => {
    const loggedEmpUserName = useSelector(selectCurrentUser);
    const [shoutoutVisible, setShoutoutVisible] = useState(false);
    const [todoVisible, setTodoVisible] = useState(false);
    const [AcknowledgeConversation] = useAcknowledgeConversationMutation();
    const [updateCoachingConversation] = useCoachingConversationMutation();
    const [DeleteCoaching] = useDeleteCoachingMutation();
    const [inputData, setInputData] = useState<any>();
    const [visibleToRecipient, setVisibleToRecipient] = useState(false);
    const currEmpId = useSelector(selectCurrentEmpid);
    const [diaDelete, setDiaDelete] = useState<boolean>(false);
    const userMngrRole = useSelector(selectCurrentUserManagerLevel);
    const [dialogEnable, setDialogEnable] = React.useState(false);
    const [description, setDescription] = React.useState('');
    const [createToDo] = useCreateCoachingToDoMutation();
    const [isAcknowledgeReqSent, setIsAcknowledgeReqSent] = React.useState(false);
    const [recipientNumber, setRecipientNumber] = React.useState<string>('');
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);
    const toaster = useRef<Toast>(null);
    const [getSignedUrl, { data: fileUrlData }] = useGetSignedUrlMutation();
    const fetchedConversationIdRef = useRef<number | null>(null);

    const conversationDocuments: string[] = Array.isArray(props.listItem?.conversation_documents)
        ? props.listItem.conversation_documents
        : [];

    useEffect(() => {
        const conversationId = props.listItem?.coaching_conversation_id;
        if (conversationDocuments.length > 0 && conversationId !== fetchedConversationIdRef.current) {
            fetchedConversationIdRef.current = conversationId;
            getSignedUrl(conversationDocuments);
        }
    }, [props.listItem?.coaching_conversation_id]);
    
    const { data: acknowledgeRequestSent } = useConversationAckReqCheckQuery(
        {
            employeeNumber: props?.listItem?.employee_number,
            conversationId: props?.listItem?.coaching_conversation_id,
        },
        {
            skip:
                props?.listItem?.employee_number == null || props?.listItem?.coaching_conversation_id == null,
        }
    );

    useEffect(() => {
        setDescription(props?.listItem?.conversation_description);
        setVisibleToRecipient(props?.listItem?.visible_to_recipient);
        setRecipientNumber(props?.listItem?.employee_number);
    }, [props?.listItem]);
    useEffect(() => {
        if (acknowledgeRequestSent?.data === true) setIsAcknowledgeReqSent(true);
        else setIsAcknowledgeReqSent(false);
    }, [acknowledgeRequestSent]);
    const handleAcknowledged = () => {
        const now = new Date();
        const payload = {
            coachingConversationId: props?.listItem?.coaching_conversation_id,
            acknowledgeEmployeeNumber: currEmpId,
            acknowledgeDate: `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`,
        };
        AcknowledgeConversation(payload)
        .unwrap()
        .then((res: any) => {
            if (res?.data) {
                toast.success('Conversation Acknowledged successfully');
                props?.setDisplayModal(false);
            } else {
                toast.error('Error Acknowledging conversation');
            }
        })
        .catch(() => {
            toast.error('Error Acknowledging conversation');
        });
    };
    const handelAddcomment = () => {
        if (props?.listItem?.acknowledged)
            toast.warning('Conversations are not editable after recipient acknowledges the conversation.');
        else props?.setCommentView(true);
    };
    const handleAssociateAcknowledge = () => {
        //update conversation visibility to true
        if (props?.listItem?.visible_to_recipient === false) {
            const payload = {
                coachingConversationId: props?.listItem?.coaching_conversation_id,
                visibleToRecipient: true,
                conversationDescription: props?.listItem?.conversation_description,
            };
            setVisibleToRecipient(true);
            updateConversation(payload);
        }
        //insert todo
        const todoStartDate = new Date();
        const todoDueDate = new Date();
        todoDueDate.setDate(todoDueDate.getDate() + 3);
        const convSub = props?.listItem?.conversation_subject ? props?.listItem?.conversation_subject : '';
        const convDate = props?.listItem?.conversation_date
            ? datetimeToDate(props?.listItem?.conversation_date)
            : '';
        const employeeNumbers = [];
        employeeNumbers.push(props?.listItem?.employee_number);
        createToDo({
            employeeNumbers,
            createBy: props?.listItem?.author_employee_number,
            coachingEntityTypeId: 2,
            coachingEntityId: props?.listItem?.coaching_conversation_id,
            title: 'Please approve Conversation',
            description:
                'Please approve the [' +
                convSub +
                '] discussion on [' +
                convDate +
                ']. Open the discussion in the Coaching, Discussions workflow. Then, add comments if you wish and click on the acknowledge box in the lower left corner.',
            startDate: datetimeToDate(todoStartDate),
            dueDate: datetimeToDate(todoDueDate),
            coachingStatusId: 1,
        })
        .unwrap()
        .then((res: any) => {
            if (res.data) {
                toast.success('To Do created successfully.');
            }
        })
        .catch(() => {
            toast.error('To Do creation failed.');
        });
    };
    const accept = () => {
        handleAssociateAcknowledge();
    };
    const reject = () => {
        toast.warning('Unable to send acknowledgement request');
    };
    const handleRequestAcknowledgement = () => {
        if (isAcknowledgeReqSent) {
            toast.warning('Acknowledgement request already sent');
        } else if (props?.listItem?.visible_to_recipient === false) {
            confirmDialog({
                message: 'Discussion must be visible to recipient.  Shall I change it to Visible?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept,
                reject,
            });
        } else {
            handleAssociateAcknowledge();
        }
    };
    const handleRecipientVisibility = (e: any, listItem: any) => {
        const payload = {
            coachingConversationId: listItem?.coaching_conversation_id,
            visibleToRecipient: e.value,
            conversationDescription: listItem?.conversation_description,
        };
        setInputData(payload);
        if (e.value) {
            setDialogEnable(true);
        } else {
            setVisibleToRecipient(e.value);
            updateConversation(payload);
        }
    };
    const updateConversation = (payload: any) => {
        updateCoachingConversation(payload)
        .unwrap()
        .then((res: any) => {
            if (res?.data) {
                toast.success('Conversation updated successfully');
            } else {
                toast.error('Error updating conversation');
            }
        })
        .catch(() => {
            toast.error('Error updating conversation');
        });
    };

    const handleConfirm = () => {
        setDialogEnable(false);
        setVisibleToRecipient(inputData?.visibleToRecipient);
        updateConversation(inputData);
    };
    const handleSave = (listItem: any) => {
        if (listItem?.conversation_description === description) {
            return;
        }
        if (description?.length < 10) {
            toast.error('Description must be at least 10 characters');
            return;
        }
        const payload = {
            coachingConversationId: listItem?.coaching_conversation_id,
            conversationDescription: description,
        };
        updateConversation(payload);
    };
    const handleCancel = () => {
        setDescription(props?.listItem?.conversation_description);
        props?.setDisplayModal(false);
    };

    const deleteIconClicked = () => {
        if (props?.listItem?.acknowledged) {
            toast.warning(
                'Once a recipient has acknowledged a conversation, it cannot be altered or deleted.'
            );
        } else if (props?.listItem?.author_employee_number !== currEmpId) {
            toast.warning('Only author can delete.');
        } else {
            setDiaDelete(true);
        }
    };

    const handleDelete = () => {
        const payload = {
            coachingId: props?.listItem?.coaching_conversation_id,
            coachingItem: 'conversation',
        };
        DeleteCoaching(payload)
        .unwrap()
        .then((res: any) => {
            if (res?.data) {
                toast.success('Conversation Deleted successfully');
                setDiaDelete(false);
                props?.setDisplayModal(false);
            } else {
                toast.error('Error Deleting conversation');
            }
        })
        .catch(() => {
            toast.error('Error Deleting conversation');
        });
    };

    const handleDescriptionChange = (value: string) => {
        setDescription(value);
    };

    return (
        <>
            <Toast ref={toaster} />
            <ConfirmDialog />
            {props?.receiverId !== currEmpId && (
                <>
                    <h6 className="me-2 mt-1 text-end">Visible to Recipient</h6>
                    <div className="d-flex justify-content-end switchbtn gap mt-2">
                        <span className="lightText">Off</span>
                        <InputSwitch
                            checked={visibleToRecipient}
                            onChange={(e) => {
                                handleRecipientVisibility(e, props?.listItem);
                            }}
                            disabled={props.readOnly}
                        />
                        <span className="lightText">On</span>
                    </div>
                </>
            )}
            <div className="logConversation mt-2">
                <div className="d-flex justify-content-start mb-2">
                    <h4 className="me-3">{props?.listItem?.conversation_subject}</h4>
                    <div className="col-1">
                        <Button
                            className="deleteBtnIcon p-button-outlined border-0 float-end me-3"
                            onClick={deleteIconClicked}
                            style={{
                                opacity:
                                    props?.listItem?.acknowledged ||
                                    props?.listItem?.author_employee_number !== currEmpId
                                        ? 0.5
                                        : 1,
                            }}
                        />
                    </div>
                </div>
                <div className="d-flex justify-content-start mb-2">
                    <div className="col-3 me-3">
                        <h6>Date</h6>
                        <div>{changeDateFormate(props?.listItem?.conversation_date)}</div>
                    </div>
                    <div className="col-3 me-3">
                        <h6>Category</h6>
                        <div>{props?.listItem?.coaching_conversation_category_name}</div>
                    </div>
                    <div className="col-3 me-3">
                        {props?.listItem?.core_value_name && (
                            <>
                                <h6>TTEC Value</h6>
                                <div>{props?.listItem?.core_value_name}</div>
                            </>
                        )}
                    </div>
                </div>
                <DescriptionBox
                    createdByLabel="Author"
                    createdByValue={loggedEmpUserName}
                    title={'Description'}
                    responseDescription={description}
                    value={description}
                    limit={4000}
                    onChange={handleDescriptionChange}
                />
                {description?.length < 10 ? (
                    <div className="errorText">Description must be at least 10 characters</div>
                ) : (
                    ''
                )}

                {fileUrlData?.data && Object.keys(fileUrlData.data).length > 0 && (
                    <>
                        <h6>Attachments ({Object.keys(fileUrlData.data).length})</h6>
                        <div className="ms-3">
                            {Object.entries(fileUrlData.data as Record<string, string>).map(
                                ([fileName, signedUrl], index) => (
                                    <div key={index} className="mb-2">
                                        <a
                                            href={signedUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="font-bold"
                                        >
                                            <i className="pi pi-file me-2" />
                                            {fileName}
                                        </a>
                                    </div>
                                )
                            )}
                        </div>
                    </>
                )}
                <div className="d-flex justify-content-between mt-3 mb-3">
                    <h6>Author : {props?.listItem?.author_name} </h6>
                    {props?.listItem?.author_employee_number === currEmpId &&
                        !props?.listItem?.acknowledged &&
                        !props.readOnly && (
                            <div className="flexButtons justify-content-end ">
                                <div>
                                    <Button
                                        label="Cancel"
                                        onClick={handleCancel}
                                        className="btn-secondary me-2"
                                    />
                                    <Button
                                        label="Save"
                                        onClick={() => handleSave(props?.listItem)}
                                        className="btn-primary"
                                    />
                                </div>
                            </div>
                        )}
                </div>
                <div className="d-flex justify-content-end gap-2">
                    {!props.listItem?.acknowledged === true &&
                        (ROLES.SupervisorOrOnlyManager.includes(userMngrRole) ||
                            isPseudoSupervisor === true) &&
                        recipientNumber !== currEmpId && (
                            <Button
                                label="Request Acknowledgement"
                                onClick={handleRequestAcknowledgement}
                                className="btn-secondary me-2"
                            />
                        )}
                    {!props.isResponse && props.commentView === false && (
                        <Button
                            label="Add comment"
                            onClick={handelAddcomment}
                            className="btn-secondary"
                        />
                    )}
                </div>
                {(props.isResponse || props.commentView) && (
                    <ReplyConversationLog
                        listItem={props.listItem}
                        setSelectedRowItem={props.setSelectedRowItem}
                        setCommentView={props.setCommentView}
                        setIsResponse={props.setIsResponse}
                        isResponse={props.isResponse}
                        readOnly={props.readOnly}
                    />
                )}
                <div className="justify-content-between mt-3 mb-3">
                    <Checkbox
                        inputId="acknowledge"
                        className="me-2"
                        disabled={
                            props?.listItem?.acknowledged ||
                            props?.listItem?.employee_number !== currEmpId?.toString()
                        }
                        value="Acknowledged"
                        checked={props?.listItem?.acknowledged}
                        onChange={handleAcknowledged}
                    />
                    <label htmlFor="acknowledge">Acknowledge By Recipient</label>
                </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-2">
                <CoachingShoutOut
                    receiverId={props.receiverId}
                    receiverName={props.receiverName}
                    visible={shoutoutVisible}
                    setVisible={setShoutoutVisible}
                    coachingEntityId={props.convId}
                    coachingEntityTypeId={2}
                    coreValueId={props.coreValueId}
                />

                <CoachingToDo
                    receiverId={props.receiverId}
                    receiverName={props.receiverName}
                    visible={todoVisible}
                    setVisible={setTodoVisible}
                    coachingEntityId={props.convId}
                    coachingEntityTypeId={2}
                    coachingStatusId={1}
                />
            </div>
            <Dialog
                visible={dialogEnable}
                style={{ width: '40vw', textAlign: 'center', zIndex: '9998' }}
                onHide={() => setDialogEnable(false)}
            >
                <div className="row">
                    <div className="col-md-12 text-center">
                        <p>Are you sure? Conversation will be visible to the associate.</p>
                        <div className="d-flex justify-content-center mt-3">
                            <Button
                                label="Cancel"
                                onClick={() => setDialogEnable(false)}
                                className="me-2 btn-secondary"
                            />
                            <Button label="Ok" onClick={handleConfirm} className="me-2 btn-primary" />
                        </div>
                    </div>
                </div>
            </Dialog>
            {diaDelete && (
                <DeleteCoachingDialog
                    diaDelete={diaDelete}
                    setDiaDelete={setDiaDelete}
                    handleDelete={handleDelete}
                />
            )}
        </>
    );
};

export default ReadConversationModalBody;
